import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import {
  extendLeaseDomainHoldClock,
  getIsLeaseDomainEnabledForPhase,
  postApplicationHoldDateFromNow,
} from "../../services/AdminDashService";
import { getConfigs } from "src/configs/Config";
import { Configuration } from "src/types/Redux";

const ResetHoldClockModal = (props) => {
  const { applicationHoldExtendTimeInMinutes } = getConfigs();
  const dispatch = useAppDispatch();
  const notification = useAppSelector(
    (state) => state.applications.notification
  );
  const [disableResetButton, setDisableResetButton] = useState(false);

  const {
    selectedApplication,
    configuration,
    onCancel,
    show,
    refreshApplicationData,
  }: { configuration?: Configuration; [key: string]: any } = props;
  const cancelAction = () => {
    onCancel();
  };
  useEffect(() => {
    setDisableResetButton(false);
    if (
      notification &&
      notification.type === "INFO" &&
      notification?.message &&
      notification.message.endsWith("has been successfully reset")
    ) {
      refreshApplicationData();
      onCancel();
    } else {
      onCancel();
    }
  }, [notification]);

  // "Reset Hold Clock" and "Extend Hold Clock" are the same real action (confirmed) - Lease
  // Domain-enabled phases route through the extend endpoint instead of legacy's holdfromnow.
  const resetHoldClock = () => {
    setDisableResetButton(true);
    const isPhaseLeaseDomainEnabled = getIsLeaseDomainEnabledForPhase(
      configuration,
      selectedApplication?.phaseId
    );

    if (isPhaseLeaseDomainEnabled) {
      dispatch(
        extendLeaseDomainHoldClock(
          selectedApplication.applicationId,
          applicationHoldExtendTimeInMinutes,
          selectedApplication.phaseId,
          configuration
        )
      );
      return;
    }

    dispatch(
      postApplicationHoldDateFromNow(
        selectedApplication.applicationId,
        applicationHoldExtendTimeInMinutes
      )
    );
  };

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      className="reset-hold-clock-modal"
    >
      <Modal.Header>
        <Modal.Title>
          <span className="cancel-icon">!</span>Reset the hold clock?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="details">
          <div className="row">
            <div className="col">
              The clock will be reset to 24 hrs. This is the only time you will
              be able to reset the clock, would you like to proceed?
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={cancelAction}
          disabled={disableResetButton}
        >
          Cancel
        </Button>
        <Button
          variant="dark"
          onClick={resetHoldClock}
          disabled={disableResetButton}
        >
          Reset
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ResetHoldClockModal;
